import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

interface ThemeContextValue {
  theme: 'light' | 'dark';
  toggle(): void;
  setTheme(t: 'light' | 'dark'): void;
}

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

const THEME_KEY = 'cg_theme_v1';

export function ThemeProvider({children}:{children:React.ReactNode}){
  const [theme,setTheme] = useState<'light'|'dark'>(()=>{
    const stored = localStorage.getItem(THEME_KEY) as 'light'|'dark'|null;
    if(stored) return stored;
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'light';
  });

  useEffect(()=>{
    localStorage.setItem(THEME_KEY, theme);
    const root = document.documentElement;
    if(theme === 'dark') root.classList.add('dark'); else root.classList.remove('dark');
  },[theme]);

  const toggle = useCallback(()=> setTheme(t=> t==='dark' ? 'light' : 'dark'),[]);

  return <ThemeContext.Provider value={{theme, toggle, setTheme}}>{children}</ThemeContext.Provider>;
}

export function useTheme(){
  const ctx = useContext(ThemeContext);
  if(!ctx) throw new Error('useTheme must be inside ThemeProvider');
  return ctx;
}
